import ViewportMgr from 'coreClasses/view/ViewportMgr';
import useWindowResize from './useWindowResize';

/**
 * @deprecated This hook is deprecated and should not be used.
 *
 * Instead of using this hook for responsive behavior, please use:
 *
 * 1. CSS Media Queries: Use CSS media queries for styling responsive layouts
 *    Example: @media (max-width: 768px) { mobile styles }
 *
 * 2. CSS-in-JS media queries: If using styled-components or similar
 *    Example: const MobileComponent = styled.div`
 *      @media (max-width: 768px) {
 *        display: none;
 *      }
 *    `;
 *
 * 3. For conditional rendering based on viewport:
 *    - Use ViewportMgr in callbacks or methods
 *    - Use components like ShowOnDesktop, ShowOnMobile for conditional rendering
 *
 * CSS media queries are more performant and provide better separation of concerns
 * between styling and logic.
 *
 * @returns {Function} A function that mimics SCSS @media mixin behavior
 */
const useMedia = () => {
	const {width} = useWindowResize(100, true);

	/**
	 * @deprecated This function is deprecated and should not be used.
	 *
	 * Instead of using this function for responsive behavior, please use:
	 *
	 * 1. CSS Media Queries: Use CSS media queries for styling responsive layouts
	 *    Example: @media (max-width: 768px) { mobile styles }
	 *
	 * 2. CSS-in-JS media queries: If using styled-components or similar
	 *    Example: const MobileComponent = styled.div`
	 *      @media (max-width: 768px) {
	 *        display: none;
	 *      }
	 *    `;
	 *
	 * 3. For conditional rendering based on viewport:
	 *    - Use ViewportMgr in callbacks or methods
	 *    - Use components like ShowOnDesktop, ShowOnMobile for conditional rendering
	 *
	 * CSS media queries are more performant and provide better separation of concerns
	 * between styling and logic.
	 *
	 * Mimics SCSS @media mixin, see pwa/thp-pwa-core/packages/scss/_responsive-media.scss
	 *
	 * @param {...string} queries - Media query strings to check
	 * @returns {boolean} True if any of the media queries match the current viewport
	 */
	const media = (...queries: string[]): boolean => {
		return ViewportMgr.media(width, ...queries);
	};

	return media;
};

export default useMedia;
